module.exports = __webpack_public_path__ + "static/img/z2.2dc07fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/z2.png
// module id = IvTI
// module chunks = 1